/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllingCostObjectDetails } from '../models/ControllingCostObjectDetails';
import type { ControllingCostObjectsOverviewsResponse } from '../models/ControllingCostObjectsOverviewsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingCostObjectsService {
    /**
     * cost objects of project
     * @param tenantId tenant_id
     * @param projectId project_id
     * @param costView cost view
     * @param startDate start_date
     * @param endDate end_date
     * @param costObjectNumbersArray cost object numbers
     * @returns ControllingCostObjectsOverviewsResponse with cost_object_numbers filter
     * @throws ApiError
     */
    public static getCostObjectOverviews(
        tenantId: string,
        projectId: string,
        costView: boolean,
        startDate?: string,
        endDate?: string,
        costObjectNumbersArray?: Array<string>,
    ): CancelablePromise<ControllingCostObjectsOverviewsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/{project_id}/cost_objects',
            path: {
                'tenant_id': tenantId,
                'project_id': projectId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'cost_object_numbers[]': costObjectNumbersArray,
                'cost_view': costView,
            },
        });
    }
    /**
     * returns the cost object details
     * @param tenantId tenant_id
     * @param projectId project_id
     * @param id id
     * @param startDate start_date
     * @param endDate end_date
     * @returns ControllingCostObjectDetails successful
     * @throws ApiError
     */
    public static getCostObjectDetails(
        tenantId: string,
        projectId: string,
        id: string,
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<ControllingCostObjectDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/{project_id}/cost_objects/{id}',
            path: {
                'tenant_id': tenantId,
                'project_id': projectId,
                'id': id,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
}
